import React from 'react';
import {Button} from "antd";
import { DownloadOutlined } from '@ant-design/icons';
import "./index.css";

const Download =()=>{
    return(
        <Button type="primary" className="downButton" shape="round" icon={<DownloadOutlined />} size={"medium"} style={{margin:"0px 5% 10px 20%",opacity:"1",background:"#038585"}}>
        Download Notes
      </Button>
    )

}

export default Download;